import { LikeSvg } from "../../SVG/LikeSvg"

export const ButtonLike = ({ onClick, clname, isLiked }) => {
    return (
        <button className={clname} onClick={onClick}>
            <LikeSvg /> {isLiked ? 'Отложено' : 'Отложить'}
        </button>
    )
}